<template>
    <div>
        <div>
            <span class="mr-5">
                <Checkbox type="checkbox"
                    name="style_fill"
                    checkValue="fill"
                    v-model="style"
                    @change="setFillStyle()"
                    >Formatfüllend
                </Checkbox>
                <Popover text="Beschreibung Formatfüllend"></Popover>
            </span>

            <span>
                <Checkbox type="checkbox"
                    name="style_repeat"
                    checkValue="repeat"
                    v-model="style"
                    @change="setFillStyle()"
                    >Wiederholung
                </Checkbox>
                <Popover text="Beschreibung Wiederholung"></Popover>
            </span>
        </div>

        <div class="mt-3">
            <textarea
                v-show="style === 'fill'"
                name="background-textarea"
                v-model="textarea"
                rows="4"
                cols="50"
                class="textarea"
                @change="setTextBackground()"></textarea>
            <input type="text" name="background-text" class="w-full"
                v-show="style === 'repeat'"
                v-model="text"
                @change="setTextBackground()">
        </div>

        <div class="mt-3 grid grid-cols-2 form-element-wrapper">
            <div class="form-element">
                <SelectBox
                    v-show="text || textarea"
                    name="background-text-font"
                    class="w-full"
                    v-model="fontFamily" @change="setTextBackground()">
                    <option :selected="fontFamily === 'Prata'">Prata</option>
                    <option :selected="fontFamily === 'Abril Fatface'">Abril Fatface</option>
                    <option :selected="fontFamily === 'Bellisia'">Bellisia</option>
                    <option :selected="fontFamily === 'Testimonia'">Testimonia</option>
                    <option :selected="fontFamily === 'Dancing Script'">Dancing Script</option>
                    <option :selected="fontFamily === 'Lato'">Lato</option>
                    <option :selected="fontFamily === 'Forum'">Forum</option>
                </SelectBox>
            </div>

            <div class="form-element">
                <ColorPicker name="background-text-fill"
                    v-show="text || textarea"
                    v-model="fill"
                    @input="setTextBackground()"
                ></ColorPicker>
            </div>
        </div>

        <div class="mt-3 grid grid-cols-2 form-element-wrapper">
            <div class="form-element" v-show="text || textarea">
                <div class="label">Textgröße</div>
                <Slider
                    min="12"
                    max="150"
                    v-model="size"
                    v-show="style === 'repeat'"
                    @change="setTextBackground()"
                ></Slider>
                <Slider
                    max="10"
                    min="0.28"
                    step="0.1"
                    v-model="scaleX"
                    ref="textSizeSlider"
                    @change="changeSize()"
                    v-show="style === 'fill'"
                ></Slider>
            </div>

            <div class="form-element" v-show="text || textarea">
                <div class="label">Transparenz</div>
                <Slider
                    name="transparency"
                    v-model="transparency"
                    @change="setTextBackground()"
                    step="5" min="0" max="95"
                ></Slider>
            </div>
        </div>
    </div>

</template>

<script>
import {mapFields} from 'vuex-map-fields';
import Slider from '~/scripts/Components/Slider.vue';
import Pipeline from "~/scripts/Pipeline/Pipeline.js";
import Popover from '~/scripts/Components/Popover.vue';
import defaults from '~/scripts/Pipeline/_defaults.js';
import Checkbox from '~/scripts/Components/Checkbox.vue';
import SelectBox from "~/scripts/Components/SelectBox.vue";
import ColorPicker from "~/scripts/Components/ColorPicker.vue";

export default {
    components: {
        Slider,
        Popover,
        Checkbox,
        SelectBox,
        ColorPicker
    },
    mounted() {
        const defaultConfig = defaults.textConfiguration;
        this.fill = this.fill != defaultConfig.fill ? this.fill : defaultConfig.fill;
        this.fontFamily = this.fontFamily != defaultConfig.fontFamily ? this.fontFamily : defaultConfig.fontFamily;

        document.getElementById('ayv-container').addEventListener('backgroundTextScaleChanged', (event) => {
            this.$refs.textSizeSlider.set(this.scaleX);
        });
    },
    computed: {
        ...mapFields({
            text: 'stageConfiguration.background.text',
            size: 'stageConfiguration.background.text_size',
            fill: 'stageConfiguration.background.text_fill',
            style: 'stageConfiguration.background.text_style',
            textarea: 'stageConfiguration.background.textarea',
            scaleX: 'stageConfiguration.background.text_scaleX',
            scaleY: 'stageConfiguration.background.text_scaleY',
            fontFamily: 'stageConfiguration.background.text_fontFamily',
            transparency: 'stageConfiguration.background.text_transparency'
        })
    },
    methods: {
        setFillStyle() {
            this.setTextBackground();
        },
        setTextBackground() {
            Pipeline.setTextBackground();
            Pipeline.setBackgroundOrder();
        },
        changeSize() {
            this.scaleY = this.scaleX;
            this.setTextBackground();
        }
    }
};
</script>
